import React, {useCallback, useEffect, useState} from 'react';

import {FileProps} from 'shared/types/file';
import {Text, Tooltip} from '@mantine/core';
import Modal from 'shared/migration-components/modal';
import {UseMutationResult} from 'react-query';
import {useModals} from '@mantine/modals';
import Loading from 'shared/migration-components/loading';

import {
  ImageWrapper,
  StyledImg,
  DeleteIcon,
  PreviewImage,
  DeleteContainer,
} from './styles';

interface Props {
  image: Omit<File, 'key'> | FileProps;
  onRemove: () => void;
  removeImage?: () => UseMutationResult<any, unknown, any, unknown>;
}

const ImagePreview: React.FC<Props> = ({image, onRemove, removeImage}) => {
  const [open, setOpen] = useState(false);
  const {openConfirmModal} = useModals();
  const {mutateAsync, isLoading, isSuccess} = removeImage
    ? removeImage()
    : ({} as UseMutationResult<any, unknown, any, unknown>);

  useEffect(() => {
    if (isSuccess) return onRemove();
  }, [isSuccess]);

  const handleDeleteImage = async () => {
    onRemove();
    // if (!('id' in image)) return onRemove();

    // await mutateAsync(undefined);
  };

  const getUrl = useCallback(() => {
    if (typeof image === 'string') return image;
    return URL.createObjectURL(image as File);
  }, [image]);

  const openModal = () =>
    openConfirmModal({
      title: 'Remover imagem',
      children: <Text size="sm">Deseja realmente remover a imagem?</Text>,
      labels: {confirm: 'Sim', cancel: 'Não'},
      onConfirm: handleDeleteImage,
    });

  return (
    <>
      <ImageWrapper>
        <StyledImg src={getUrl()} alt="Imagem" onClick={() => setOpen(true)} />
        <Tooltip label="Remover imagem" withArrow>
          <DeleteContainer>
            {!isLoading && <DeleteIcon size={28} onClick={openModal} />}
            {isLoading && <Loading />}
          </DeleteContainer>
        </Tooltip>
      </ImageWrapper>
      <Modal
        opened={open}
        onClose={() => setOpen(false)}
        size="xl"
        centered
        title="Pré-visualização da imagem">
        <PreviewImage src={getUrl()} alt="Pré-visualização da imagem" />
      </Modal>
    </>
  );
};

export default ImagePreview;
